// @ts-strict-ignore
import { CmsApiFreeCodeBlockData } from 'modules/cms/api/types/CmsApiFreeCode';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsFreeCodeBlock } from './CmsFreeCodeBlock';

export const CmsFreeCodeBlockMapping: CmsBlockMapping<CmsApiFreeCodeBlockData> =
  {
    invariant: [
      {
        prop: 'code',
        msg: 'Code required',
      },
    ],
    width: CmsBlockWidth.INSET,
    Component: CmsFreeCodeBlock,
    AmpComponent: null,
  };
